import * as API from "@/data/api/users";
import {
  RequestParams,
  TUserItem,
  TUserProfilePayload,
  TUserSelf,
  TUserSelfInvitationItem,
  TUserSelfPayload,
} from "@/data/types";
import { State } from "../state/state";
import { createTypedAsyncThunk, withOrgId } from "../utils/actions";

export const getAllUsersAsync = createTypedAsyncThunk<
  TUserItem[],
  RequestParams,
  { state: State }
>("users/getAllUsers", async (params, { getState }) => {
  return API.getAllUsers(withOrgId(getState, params));
});

export const getSelfAsync = createTypedAsyncThunk<
  TUserSelf,
  RequestParams | undefined,
  { state: State }
>("users/getSelf", async (params, { getState }) => {
  return API.getSelf(withOrgId(getState, params));
});

export const updateSelfAsync = createTypedAsyncThunk<
  TUserSelf,
  TUserSelfPayload,
  { state: State }
>("users/updateSelf", async (payload, { getState }) => {
  return API.updateSelf(withOrgId(getState), payload);
});

export const deleteSelfAsync = createTypedAsyncThunk<
  void,
  undefined,
  { state: State }
>("users/deleteSelf", async (_, { getState }) => {
  return API.deleteSelf(withOrgId(getState));
});

export const getUserByIdAsync = createTypedAsyncThunk<
  TUserItem,
  { userId: string; params?: RequestParams },
  { state: State }
>("users/getUserById", async ({ userId, params }, { getState }) => {
  return API.getUserById(userId, withOrgId(getState, params));
});

export const deleteUserAsync = createTypedAsyncThunk<
  void,
  { userId: string; params?: RequestParams },
  { state: State }
>("users/deleteUser", async ({ userId, params }, { getState }) => {
  return API.deleteUser(userId, withOrgId(getState, params));
});

export const updateUserProfileAsync = createTypedAsyncThunk<
  TUserItem,
  { userId: string; params?: RequestParams; payload: TUserProfilePayload },
  { state: State }
>(
  "users/updateUserProfile",
  async ({ userId, params, payload }, { getState }) => {
    return API.updateUserProfile(userId, withOrgId(getState, params), payload);
  }
);

export const getSelfInvitationsAsync = createTypedAsyncThunk<
  { items: TUserSelfInvitationItem[] },
  RequestParams | undefined,
  { state: State }
>("users/getSelfInvitations", async (params, { getState }) => {
  return API.getSelfInvitations(withOrgId(getState, params));
});

export const acceptSelfInvitationAsync = createTypedAsyncThunk<
  unknown,
  string,
  { state: State }
>("users/acceptSelfInvitation", async (id, { getState }) => {
  return API.acceptSelfInvitation(id, withOrgId(getState));
});

export const rejectSelfInvitationAsync = createTypedAsyncThunk<
  unknown,
  string,
  { state: State }
>("users/rejectSelfInvitation", async (id, { getState }) => {
  return API.rejectSelfInvitation(id, withOrgId(getState));
});
